import {createFileRoute} from '@tanstack/react-router';

import {companyKeys} from '@/features/User/api/queryKeys';
import {getCompany} from '@/features/User/api/readCompany';
import {InviteForm} from '@/features/User/components/InviteForm';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/_company/users_/invite')({
  component: InviteForm,

  beforeLoad: ({context}) => {
    makeDocumentTitle(`Invite User`);

    return {
      ...context,
      readCompanyQuery: {
        queryKey: companyKeys.all,
        queryFn: () => getCompany(),
      },
    };
  },

  loader({context}) {
    return context.queryClient.ensureQueryData(context.readCompanyQuery);
  },
});
